import lodashGet from 'lodash.get';
import BaseModel from '../../core/baseModel';
import * as registry from '../../../home24/core/registry';
import * as config from '../../../home24/core/config';

export default BaseModel.extend({
    defaults: {
        structure: {},

        commentRequired: {},

        maxCommentLength: config.get('fttc2.validation.comment.maxLength'),

        commentFieldVisible: false,

        commentFieldValid: true,
        selectsValid: true,
        imagesValid: true,

        differentComplainsVisible: false,
        type: ''
    },

    initialize: function () {
        this.set({
            structure: registry.get('reclamationTreeStructure'),
            translations: registry.get('reclamationTranslations')
        });
    },

    getCategories: function (type) {
        return this.get('structure')[type];
    },

    getReasons: function (type, category) {
        return this.get('structure')[type].children[category];
    },

    getReasonOptions: function (path) {
        if (path) {
            return lodashGet(this.get('structure'), path.replace(/\./g, '.children.'), {});
        }

        return {};
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step2Model.js
 **/